import _ from "lodash";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";

dayjs.extend(isBetween);

export const showPromotions = promotions => {
  const curentPromotions = _.filter(promotions, promotion => {
    const start = _.get(promotion, "promotion_start_time");
    const end = _.get(promotion, "promotion_end_time");
    if (start === null || end === null) {
      return true;
    }
    return dayjs().isBetween(start, end, null, "[]");
  });
  const orderCurrentPromotions = _.sortBy(
    curentPromotions,
    "promotion_start_time"
  );

  const upcommingPromotions = _.filter(promotions, promotion => {
    const start = _.get(promotion, "promotion_start_time");
    return dayjs().isBefore(start);
  });
  const orderUpcommingPromotions = _.sortBy(
    upcommingPromotions,
    "promotion_start_time"
  );

  const showItems = [...orderCurrentPromotions, ...orderUpcommingPromotions];
  return showItems;
};



// WEBPACK FOOTER //
// ./src/selectors/promotion.js